import React, { useState, useRef } from 'react';
import { Grid, Row, Col, Button, Panel, PanelGroup } from 'react-bootstrap';
import ConfigureEvent from './configureEvent';
import ConfigureScreen from './configureScreen';
import Tokens from './tokens';
import SelectEvent from './selectEvent';
import SelectScreen from './selectScreen';
import Image from './image';
import DisplayClock from './displayClock';
import './css/configure.css';

export default function Configure({ userProfile, exitConfigMode, configInNewMode }) {
    const configScreenRef = useRef(null);

    const [currentEventID, setCurrentEventID] = useState(0);
    const [screenEventID, setScreenEventID] = useState(0);
    const [tokenEventID, setTokenEventID] = useState(0);
    const [modulesConfiguredCount, setModulesConfiguredCount] = useState(0);
    const [screenCountForEvent, setScreenCountForEvent] = useState(99);
    const [screenMode, setScreenMode] = useState('configure');
    const [selectedScreen, setSelectedScreen] = useState({ eventScreenID: 0 });
    const [refreshScreenList, setRefreshScreenList] = useState(0);
    const [refreshModulesInUse, setRefreshModulesInUse] = useState(0);
    const [activeKey, setActiveKey] = useState('');

    function newEventScreenModuleSelected(screen) {
        const maxCols = screen.deviceType === 'mobilePortrait' ? 4 : screen.deviceType === 'mobileLandscape' ? 8 : 12;
        const maxRows = screen.deviceType === 'mobilePortrait' ? 10 : screen.deviceType === 'mobileLandscape' ? 5 : screen.deviceType === 'tablet' ? 13 : 12;
        setSelectedScreen({ ...screen, maxCols, maxRows });
    }

    function newEventSelected(eventID) {
        setActiveKey('');
        setSelectedScreen({ eventScreenID: 0, screenName: '' });
        setCurrentEventID(eventID);
        setRefreshModulesInUse(prev => prev + 1);
    }

    function displayClock() {
        setActiveKey('');
        setScreenMode('clock');
        configInNewMode('clock');
    }

    function exitDisplayClock() {
        setScreenMode('configure');
        configInNewMode('configure');
    }

    const configureDivStyle = { display: screenMode === 'configure' ? 'block' : 'none' };
    const emptyRowStyle = { height: '20px' };
    const headStyle = { fontSize: '20px', marginTop: '20px', height: '40px' };

    return (
        <div style={{ height: '100%', overflowY: 'auto' }} ref={configScreenRef}>
            <div style={configureDivStyle}>
                <div style={{ width: 120, height: 120, position: 'relative', top: 20, left: 20, marginBottom: 20 }}>
                    <a href="http://www.radio.management/" target="_blank">
                        <Image style={{ marginTop: '10px' }} src={window.location.href + 'staticImages/orquestraDio.svg'} width={100} height={100} mode='fit' />
                    </a>
                </div>
                <Grid fluid={true}>
                    <Row style={headStyle}>
                        <Col xs={12}><span>Configure Events &amp; Dashboards</span></Col>
                    </Row>
                    <Row>
                        <SelectEvent
                            newEventSelected={newEventSelected}
                            userProfile={userProfile}
                            configuredItemCount={screenCountForEvent + modulesConfiguredCount}
                            allowForNewEvent={true} />
                    </Row>
                    <Row style={emptyRowStyle} />
                    <Row>
                        <Col xs={12}>
                            <PanelGroup id="event-maintenance" accordion activeKey={activeKey} onSelect={setActiveKey}>
                                <Panel eventKey="1">
                                    <Panel.Heading>
                                        <Panel.Title toggle>Modules to be included</Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Collapse onEntered={() => setRefreshModulesInUse(prev => prev + 1)}>
                                        <Panel.Body collapsible>
                                            <ConfigureEvent
                                                userProfile={userProfile}
                                                eventID={currentEventID}
                                                refreshModulesInUse={refreshModulesInUse}
                                                configuredModules={setModulesConfiguredCount} />
                                        </Panel.Body>
                                    </Panel.Collapse>
                                </Panel>
                                <Panel eventKey="2">
                                    <Panel.Heading>
                                        <Panel.Title toggle>Configure Dashboards</Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Collapse
                                        onEntering={() => setScreenEventID(0)}
                                        onEntered={() => { setScreenEventID(currentEventID); window.dispatchEvent(new Event('resize')); }}>
                                        <Panel.Body collapsible>
                                            <ConfigureScreen
                                                userProfile={userProfile}
                                                eventID={screenEventID}
                                                modulesConfiguredCount={modulesConfiguredCount}
                                                screenCountForEvent={setScreenCountForEvent}
                                                newEventScreenAdded={(screen) => {
                                                    setRefreshScreenList(prev => prev + 1);
                                                    setSelectedScreen(screen);
                                                }} />
                                        </Panel.Body>
                                    </Panel.Collapse>
                                </Panel>
                                <Panel eventKey="3">
                                    <Panel.Heading>
                                        <Panel.Title toggle>Tokens</Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Collapse
                                        onEntering={() => setTokenEventID(0)}
                                        onEntered={() => setTokenEventID(currentEventID)}>
                                        <Panel.Body collapsible>
                                            <Tokens
                                                userProfile={userProfile}
                                                eventID={tokenEventID}
                                                configuredModules={setModulesConfiguredCount} />
                                        </Panel.Body>
                                    </Panel.Collapse>
                                </Panel>
                            </PanelGroup>
                        </Col>
                    </Row>
                    <Row style={headStyle}>
                        <Col xs={12}><span>Test Dashboards</span></Col>
                    </Row>
                    <Row>
                        <SelectScreen
                            newEventScreenModuleSelected={newEventScreenModuleSelected}
                            newItemsCreated={() => {}}
                            screenCountForEvent={setScreenCountForEvent}
                            userProfile={userProfile}
                            eventID={currentEventID}
                            refreshScreenList={refreshScreenList}
                            allowForNewScreen={false}
                            selectedScreen={selectedScreen} />
                    </Row>
                    <Row style={emptyRowStyle} />
                    <Row>
                        <Col xs={3} sm={2} md={2} lg={1} style={{ paddingRight: 0 }}>
                            <Button key="display" name="display"
                                disabled={selectedScreen.eventScreenID === 0}
                                block bsStyle="primary"
                                onClick={displayClock}>
                                Test
                            </Button>
                        </Col>
                    </Row>
                    <Row style={emptyRowStyle} />
                    <Row>
                        <Col xs={8} sm={8} md={9} lg={10} />
                        <Col xs={3} sm={2} md={2} lg={1} style={{ paddingRight: 0 }}>
                            <Button key="exit" name="exit" bsStyle="danger"
                                style={{ width: '100%', paddingLeft: 0, paddingRight: 0 }}
                                className="pull-right"
                                onClick={exitConfigMode}>
                                Exit
                            </Button>
                        </Col>
                    </Row>
                </Grid>
            </div>
            <div>
                {screenMode === 'clock' && (
                    <DisplayClock
                        key="displayclock"
                        selectedScreen={{ ...selectedScreen, eventID: currentEventID, mode: 'test', maxCols: 12, maxRows: 12 }}
                        userProfile={userProfile}
                        exitDisplayClock={exitDisplayClock}
                        windowHeight={configScreenRef.current?.offsetHeight ?? 0} />
                )}
            </div>
        </div>
    );
}
